import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["toast","error"] */ "/app/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/governance_actions/governanceActionsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/seo/hubControls.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/seo/searchBox.tsx");
